import React from 'react'
import moment from 'moment'
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit'

const AwardList = ({ year, awards }) => (
  <div>
    <div>
      <h6>{year}</h6>
    </div>
    <ul>
      {Object.keys(awards || {}).map((awardLevel, idx) => (
        <div key={`pip-award-level-${year}-${idx}}`}>
          <strong>{awardLevel}</strong>&nbsp;
          <small>({moment(awards[awardLevel].ack_on).format('M/D/YY')})</small>
        </div>
      ))}
    </ul>
  </div>
)

export const AwardListModal = ({ data, show, onClose }) => {
  const awardsExist = d => d && typeof d === 'object' && Object.keys(d).length > 0
  return (
    <MDBModal open={show} tabIndex='-1' onClose={() => onClose(false)}>
      <MDBModalDialog>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Agent Milestone Awards</MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={() => onClose(false)}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            {awardsExist(data)
              ? Object.keys(data)
                  .filter(year => awardsExist(data[year]))
                  .map((year, idx) => {
                    return <AwardList key={`pip-award--${year}-${idx}`} awards={data[year]} year={year} />
                  })
              : 'This agent has not won any milestone awards.'}
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type='button' color='danger' size='sm' onClick={() => onClose(false)}>
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}
